export const beforeItems = [
  "You sometimes struggle to decide which aspects of a patient's history deserve further investigation.",
  'You spend too much time searching for relevant assessment information.',
  'You find it challenging to connect subjective symptoms with physical examination findings.',
  'You want a more systematic approach to recognizing potentially concerning presentations.',
  'You struggle to organize competing clinical hypotheses.',
  'You find yourself approaching unfamiliar cases without a consistent process.',
];

export const afterItems = [
  'You have a structured reference for organizing the initial interview.',
  'You can document relevant symptoms, functional limitations, and examination findings more systematically.',
  'You have dedicated educational resources for reviewing potential warning signs.',
  'You can organize your examination findings by category.',
  'You have worksheets for making your clinical reasoning more transparent.',
  'You can practice applying your knowledge through educational case scenarios.',
];

export const situations = [
  {
    title: 'Your Patient Reports Low Back Pain With Symptoms Extending Into the Leg.',
    body: 'You need to organize the history, relevant examination findings, and neurological considerations without jumping to conclusions based on a single symptom.',
  },
  {
    title: 'You Want a More Systematic Approach to Red-Flag Screening.',
    body: 'You understand that some presentations may indicate serious underlying conditions, and you want a clearer framework for organizing relevant questions, findings, and referral considerations.',
  },
  {
    title: 'You Collect Findings but Struggle to Connect Them.',
    body: 'You ask questions, perform examination procedures, and observe movement. However, turning that information into a coherent clinical picture can take time.',
  },
  {
    title: 'You Want to Improve Your Clinical Documentation.',
    body: "You want your notes to reflect the patient's presentation, relevant examination findings, clinical reasoning, and decisions about further assessment.",
  },
  {
    title: 'You Sometimes Feel Unsure About What to Investigate Next.',
    body: "When findings don't fit the expected pattern, you want a structured way to identify missing information and consider alternative explanations.",
  },
  {
    title: 'You Want a Repeatable Framework for Your Initial Assessments.',
    body: "You don't want to start from scratch with every unfamiliar presentation. You want an organized reference that supports a consistent process without replacing your professional judgment.",
  },
];

export const pillars = [
  { title: 'Structure', body: 'Organize your initial interview and gather relevant clinical information.' },
  { title: 'Screening', body: 'Review important warning signs and understand when additional medical evaluation may be necessary.' },
  { title: 'Examination', body: 'Use a structured reference to organize relevant physical examination components.' },
  { title: 'Clinical Reasoning', body: 'Bring the findings together while considering alternative explanations and recognizing uncertainty.' },
  { title: 'Practice', body: 'Use educational case scenarios to review how the different elements work together.' },
];

export const guaranteeItems = [
  'Review all six volumes.',
  'Explore the assessment frameworks.',
  'Examine the screening reference.',
  'Use the worksheets to organize your learning.',
  'Work through the educational case scenarios.',
];
